import {
    tss,
} from 'app/tss'

export default tss
    .withParams<{shortenMode: boolean}>()
    .create(({
        theme, shortenMode,
    }) => {
        const quoteInformation = 'quoteInformation'
        const general = 'general'
        const deliveryOptions = 'deliveryOptions'
        const contactDetails = 'contactDetails'

        const shortenTemplateColumns = shortenMode ? 1 : 3
        const gridTemplateAreas = shortenMode ? `"${quoteInformation} ${quoteInformation} ${quoteInformation}"` : `
                "${quoteInformation} ${quoteInformation} ${quoteInformation}"
                "${general} ${general} ${deliveryOptions}"
                "${contactDetails} ${contactDetails} ${contactDetails}"
                `

        return {
            gridWrapper: {
                display: 'grid',
                gridGap: theme.spacing(2),
                gridTemplateAreas,
                gridTemplateColumns: `repeat(${shortenTemplateColumns}, 3fr)`,
                padding: `${theme.spacing(1)}`,
            },
            quoteInformation: {
                gridArea: quoteInformation,
            },
            general: {
                gridArea: general,
                height: 'fit-content',
            },
            deliveryOptions: {
                gridArea: deliveryOptions,
                height: 'fit-content',
            },
            contactDetails: {
                gridArea: contactDetails,
            },
        }
    })
